window.jjk = window.jjk || {};
window.jjk.bootstrapModalHelper = (function (window, $, undefined) {
	// eslint-disable-line no-unused-vars
	'use strict';

	/**
	 * @typedef {Object} jjkBootstrapModalButton
	 * @property {string} text
	 * @property {string} cssKlassen
	 * @property {string} tooltip
	 * @property {bool} modalSchliessen [...]
	 */

	/**
	 * Zeigt einen Alert im Boostrap-Stil an
	 *
	 * @param {string} msg Nachricht, die angezeigt werden soll
	 * @param {string} [modalClass] CSS-Klasse des Modals, bspw. zur Größen-Anpassung
	 * @param {string} [iconClass] CSS-Klasse des Icons, wenn es kein Warndreieck sein soll
	 * @returns {void}
	 */
	function alert(msg, modalClass = '', iconClass = 'fa fa-exclamation-triangle jjk-bootstrapmodalhelper-alert-icon') {
		const $elem = $(`
			<div class="modal" tabindex="-1" role="dialog">
				<div class="modal-dialog modal-dialog-centered ${modalClass || ''}">
					<div class="modal-content">
						<div class="modal-body">
							<div class="d-flex">
								<i class="fa-3x me-4 ${iconClass}"></i>
								<span>${msg}</span>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-light" data-bs-dismiss="modal">OK</button>
						</div>
					</div>
				</div>
			</div>
			`);
		$elem.appendTo('.jjk-webinnovations-container');
		$elem.modal({ backdrop: true, focus: true });
		$elem.on('hidden.bs.modal', function () {
			$(this).remove();
		});
		$elem.modal('show');
	}

	/**
	 * Zeigt eine "MessageBox" im Boostrap-Stil an
	 *
	 * @param {string} msg Nachricht, die angezeigt werden soll
	 * @param {string} [modalClass] CSS-Klasse des Modals, bspw. zur Größen-Anpassung
	 * @param {string} [title] Titel des Modals
	 * @param {jjkBootstrapModalButton[]} [buttons] Buttons, die im Modal angezeigt werden sollen, statt nur ein "OK". Wichtig: Jeder Button muss einen Click-Event-Handler erhalten, der das Modal schließt.
	 * @returns {JQuery} Modal Element
	 */
	function message(msg, modalClass, title, buttons = []) {
		/* eslint-disable prefer-template */
		const $elem = $(
			`
			<div class="modal" tabindex="-1" role="dialog">
				<div class="modal-dialog modal-dialog-centered ${modalClass}">
					<div class="modal-content">` +
				(title
					? `<div class="modal-header">
											   <h5 class="modal-title">${title}</h5>
											   <button type="button" class="btn-close align-self-center" data-bs-dismiss="modal" aria-label="Schließen">
											   </button>
										   </div>`
					: '') +
				`<div class="modal-body">
								${msg}
						</div>
						<div class="modal-footer">` +
				(buttons.length
					? buttons.reduce(
							(output, button) =>
								(output += `<button type="button" class="btn ${button.cssKlassen}" title="${button.tooltip ? button.tooltip.replace(/"/gi, '&quot;') : ''}" ${button.modalSchliessen ? 'data-bs-dismiss="modal"' : ''}>${button.text}</button>`),
							''
						)
					: '<button type="button" class="btn btn-light" data-bs-dismiss="modal">OK</button>') +
				`</div>
					</div>
				</div>
			</div>
			`
		);
		/* eslint-enable prefer-template */
		$elem.appendTo('.jjk-webinnovations-container');
		$elem.modal({ backdrop: true, focus: true });
		$elem.on('hidden.bs.modal', function () {
			$(this).remove();
		});
		$elem.modal('show');
		return $elem;
	}

	/**
	 * Zeigt einen Bestätigungs-Dialog mit 2 Buttons an
	 *
	 * @param {Function} callback Callback bei Bestätigung
	 * @param {string} msg Text des Dialogs
	 * @param {string} [title] Titel des Dialogs (Default: Sind Sie sicher?)
	 * @param {string} [jaText] Text des "Ja"-Buttons (Default: Ja)
	 * @param {string} [neinText] Text des "Nein"-Buttons (Default: nein)
	 * @param {string} [jaCssKlasse] CSS-Klasse des "Ja"-Buttons (Default: btn-success)
	 * @param {string} [neinCssKlasse] CSS-Klasse des "Nein"-Buttons (Default: btn-light)
	 * @param {string} [modalClass] CSS-Klasse des Modals, bspw. zur Größen-Anpassung
	 * @param {string} [iconClass] CSS-Klasse des Icons
	 * @returns {void}
	 */
	function confirm(
		callback,
		msg,
		title = 'Sind Sie sicher?',
		jaText = 'Ja',
		neinText = 'Nein',
		jaCssKlasse = 'btn-success',
		neinCssKlasse = 'btn-light',
		modalClass = '',
		iconClass = 'fa fa-3x fa-question-circle me-4 jjk-bootstrapmodalhelper-confirm-icon'
	) {
		const messageText = iconClass
			? `<div class="d-flex">
				  <i class="${iconClass}"></i>
				  <span>${msg}</span>
			   </div>`
			: `<span>${msg}</span>`;
		const $modal = message(messageText, modalClass, title, [
			{ text: jaText, cssKlassen: `btn-confirm-ja ${jaCssKlasse}` },
			{ text: neinText, cssKlassen: `btn-confirm-nein ${neinCssKlasse}` },
		]);
		$modal.find('.btn-confirm-ja').on('click', () => {
			if (typeof callback == 'function') {
				callback();
			}
			$modal.modal('hide');
		});
		$modal.find('.btn-confirm-nein').on('click', () => {
			$modal.modal('hide');
		});
	}

	/**
	 * Zeigt einen Bestätigungs-Dialog mit 3 Buttons an
	 *
	 * @param {function(bool): void|Promise<void>} callback Callback bei Ja oder Nein (erster Parameter: true = Ja, false = Nein)
	 * @param {string} msg Text des Dialogs
	 * @param {string} [title] Titel des Dialogs (Default: Sind Sie sicher?)
	 * @param {string} [jaText] Text des "Ja"-Buttons (Default: Ja)
	 * @param {string} [neinText] Text des "Nein"-Buttons (Default: Nein)
	 * @param {string} [abbrechenText] Text des "Abbrechen"-Buttons (Default: Abbrechen)
	 * @param {string} [jaCssKlasse] CSS-Klasse des "Ja"-Buttons (Default: btn-success)
	 * @param {string} [neinCssKlasse] CSS-Klasse des "Nein"-Buttons (Default: btn-danger)
	 * @param {string} [abbrechenCssKlasse] CSS-Klasse des "Abbrechen"-Buttons (Default: btn-light)
	 * @param {string} [modalClass] CSS-Klasse des Modals, bspw. zur Größen-Anpassung
	 * @param {string} [iconClass] CSS-Klasse des Icons
	 * @returns {void}
	 */
	function confirmMitAbbrechen(
		callback,
		msg,
		title = 'Sind Sie sicher?',
		jaText = 'Ja',
		neinText = 'Nein',
		abbrechenText = 'Abbrechen',
		jaCssKlasse = 'btn-success',
		neinCssKlasse = 'btn-danger',
		abbrechenCssKlasse = 'btn-light',
		modalClass = '',
		iconClass = 'fa fa-3x fa-question-circle me-4 jjk-bootstrapmodalhelper-confirm-icon'
	) {
		const messageText = iconClass
			? `<div class="d-flex">
				  <i class="${iconClass}"></i>
				  <span>${msg}</span>
			   </div>`
			: `<span>${msg}</span>`;
		const $modal = message(messageText, modalClass, title, [
			{ text: jaText, cssKlassen: `btn-confirm-ja ${jaCssKlasse}` },
			{ text: neinText, cssKlassen: `btn-confirm-nein ${neinCssKlasse}` },
			{ text: abbrechenText, cssKlassen: `btn-confirm-abbrechen ${abbrechenCssKlasse}` },
		]);
		$modal.find('.btn-confirm-ja').on('click', () => {
			if (typeof callback == 'function') {
				callback(true);
			}
			$modal.modal('hide');
		});
		$modal.find('.btn-confirm-nein').on('click', () => {
			if (typeof callback == 'function') {
				callback(false);
			}
			$modal.modal('hide');
		});
		$modal.find('.btn-confirm-abbrechen').on('click', () => {
			$modal.modal('hide');
		});
	}

	return {
		alert,
		message,
		confirm,
		confirmMitAbbrechen,
	};
})(window, jQuery);
